import { ITypedModel } from 'core-ts-types';
import { ICourseDetails, ISection } from '../../../interfaces/scheduler_interfaces';
import { Model } from 'utility-ts-orm';

export interface ICourseDetailsModel {
  course_detail?: ICourseDetails;
  sectionUsedToFetchCourseDetails?: ISection['id'];
}

export type CourseDetailsModel = ITypedModel<ICourseDetailsModel>;

angular.module('capability-ng-scheduler').factory(
  'ngCourseDetailsModel',
  () =>
    new Model<ICourseDetailsModel>({
      course_detail: undefined,
      sectionUsedToFetchCourseDetails: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/models/course_details_model.ts